import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IonContent, IonItem } from '@ionic/angular/standalone';

import { Subscription } from 'rxjs';

import { CloseButtonComponent, HeaderComponent } from '../../components';
import { NotificationsService } from '../../services/notifications/notifications.service';
import { UserNotificationInterface } from '../../types/notification';
import { LoadingStateComponent } from '../states';

@Component({
    selector: 'lib-notifications',
    standalone: true,
    imports: [IonItem, IonContent, CommonModule, HeaderComponent, LoadingStateComponent, CloseButtonComponent],
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.css'
})
export class NotificationsComponent implements OnInit, OnDestroy {
    router = inject(Router);

    notifications: UserNotificationInterface[] = [];
    loaded: boolean = false;

    notificationSubscription!: Subscription;

    constructor(private notificationsService: NotificationsService) {}

    ngOnInit(): void {
        this.notificationSubscription = this.notificationsService.notifications$.subscribe(notifications => {
            this.notifications = notifications;
            this.loaded = true;
            console.log(notifications);
        });
    }

    ngOnDestroy(): void {
        this.notificationSubscription.unsubscribe();
    }

    clickNotification(notification: UserNotificationInterface) {
        const path = `/job/${notification.appointment_id}`;
        if (notification.notification_type === 'chat') {
            this.router.navigateByUrl(`${path}/messages`);
        } else if (notification.notification_type === 'appointment-review-r') {
            this.router.navigateByUrl(`${path}/review`);
        } else {
            this.router.navigateByUrl(path);
        }
    }

    removeNotification(id: number) {
        this.notificationsService.removeNotification(id);

        this.notifications = this.notifications.filter(n => {
            return n.id !== id;
        });

        this.notificationsService.updateUserNotifications(this.notifications);
    }
}
